export enum SystemClaim {
  ProjectComment = 'Engage.Project.Comment',
  ProjectPublish = 'Engage.Project.Publish',
  ProjectManage = 'Engage.Project.Manage',
  ProjectCreate = 'Engage.Project.Create',
  ProjectView = 'Engage.Project.View',
  ClientViewAll = 'Engage.Client.ViewAll',
  UserInvite = 'Engage.User.Invite',
  AdminAccess = 'Engage.Admin.Access',
  PostView = 'Engage.Post.View',
  PostManage = 'Engage.Post.Manage',
}

export const SystemClaimMetadata: {
  [key in SystemClaim]: { displayName: string; description: string; category: string };
} = {
  [SystemClaim.ProjectComment]: {
    displayName: 'Add Comments',
    description: 'Can add comments to project content',
    category: 'Project',
  },
  [SystemClaim.ProjectPublish]: {
    displayName: 'Publish Content',
    description: 'Can publish content and create posts',
    category: 'Project',
  },
  [SystemClaim.ProjectManage]: {
    displayName: 'Manage Project',
    description: 'Can edit project details and manage project users',
    category: 'Project',
  },
  [SystemClaim.ProjectCreate]: {
    displayName: 'Create Projects',
    description: 'Can create new projects',
    category: 'Global',
  },
  [SystemClaim.ClientViewAll]: {
    displayName: 'View All Clients',
    description: 'Can view projects from all clients',
    category: 'Global',
  },
  [SystemClaim.UserInvite]: {
    displayName: 'Invite Users',
    description: 'Can invite users to projects',
    category: 'Project',
  },
  [SystemClaim.AdminAccess]: {
    displayName: 'Admin Access',
    description: 'Can access admin section',
    category: 'Admin',
  },
  [SystemClaim.PostView]: {
    displayName: 'View Posts',
    description: 'Can view posts and content',
    category: 'Project',
  },
  [SystemClaim.PostManage]: {
    displayName: 'Manage Posts',
    description: 'Can create, edit, and delete posts',
    category: 'Project',
  },
  [SystemClaim.ProjectView]: {
    displayName: 'View Project',
    description: 'Can view project and basic content',
    category: 'Project',
  },
};
